module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      'loader',
      _vm.loaderClass,
      {
        'loader--intro': _vm.appState.intro,
        'is--intro': !_vm.appState.init,
        'is--active': _vm.appState.loading && _vm.appState.init,
      }
    ]
  }, [_c('div', {
    staticClass: "loader__layer loader__layer--bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader__layer loader__layer--accent"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c717d6ec"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Loader.vue
// module id = 37
// module chunks = 1